module.exports = __webpack_public_path__ + "static/media/icon-equipment.png";